"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CartItemPromoState = /** @class */ (function () {
    function CartItemPromoState() {
    }
    return CartItemPromoState;
}());
exports.default = CartItemPromoState;
//# sourceMappingURL=CartItemPromoState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/atoms/CartItemPromo/CartItemPromoState.js
// module id = 2281
// module chunks = 8